module.exports = __webpack_public_path__ + "statics/img/1.298142c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/solution/1.png
// module id = lnKI
// module chunks = 1